import type { SupabaseClient } from '@supabase/supabase-js'
import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from './config'

/**
 * supabase-js 는 필요할 때만 받는다 (로그인 창을 열었거나, 저장된 세션이 있을 때).
 * PKCE 흐름: 로그인 복귀 주소의 ?code= 를 같은 브라우저의 검증값으로 바꿔 세션을 만든다.
 */
let clientPromise: Promise<SupabaseClient> | null = null

export function loadSupabase(): Promise<SupabaseClient> {
  clientPromise ??= import('@supabase/supabase-js').then(({ createClient }) =>
    createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        flowType: 'pkce',
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    }),
  )
  return clientPromise
}
